import { ModuleInitializer, ModuleInitializerHelper } from '@workflow/helper/module-initializer/module-initializer.class';
import { OaoCustomFunctionsService } from './services/logic-functions/oao-custom-functions.service';
import { OaoOnChangeFunctionsService } from './services/logic-functions/oao-on-change-functions.service';
import { OaoOnClickFunctionsService } from './services/logic-functions/oao-on-click-functions.service';
import { OaoVisibleFunctionsService } from './services/logic-functions/oao-visible-functions.service';
import { OaoCardValidationFunctionsService } from './services/validations/oao-card-validation-functions.service';
import { OaoFieldValidationFunctionsService } from './services/validations/oao-field-validation-functions.service';
import { OaoPageValidationFunctionsService } from './services/validations/oao-page-validation-functions.service';

const OAO = 'oao';
export class OaoModuleInit {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static init(routeInit?: { PageComponent: any; guard: any }): ModuleInitializer {
    const initializer = new ModuleInitializerHelper()
      .AddValidationService(OaoPageValidationFunctionsService)
      .AddValidationService(OaoCardValidationFunctionsService)
      .AddValidationService(OaoFieldValidationFunctionsService)

      .AddLogicService(OaoCustomFunctionsService)
      .AddLogicService(OaoVisibleFunctionsService)
      .AddLogicService(OaoOnChangeFunctionsService)
      .AddLogicService(OaoOnClickFunctionsService);

    if (routeInit) {
      initializer.AddRoute('', routeInit.PageComponent, routeInit.guard, OAO);
    }
    return initializer;
  }
}
